import { render, staticRenderFns } from "./DemoDatatableKitchenSink.vue?vue&type=template&id=5e9a4f4f&scoped=true&"
import script from "./DemoDatatableKitchenSink.vue?vue&type=script&lang=js&"
export * from "./DemoDatatableKitchenSink.vue?vue&type=script&lang=js&"
import style0 from "./DemoDatatableKitchenSink.vue?vue&type=style&index=0&id=5e9a4f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a4f4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCardText,VChip,VCol,VDataTable,VIcon,VImg,VRow,VTextField})
